// Auto-generated by the generator
// Don't manually edit this file

// @flow

import {enterPlaceDetailEffect} from './enterPlaceDetail'
import {enterPlaceListEffect} from './enterPlaceList'

export const placeEffects = [
  enterPlaceDetailEffect,
  enterPlaceListEffect,
]
